import {
  SocketMessageEventType,
  StompMessageKind,
} from "redux/stomp/interface";
import {
  BasePagination,
  CommonPageResponse,
  SORT_DIRECTION,
} from "./commonInterface.interface";

export enum NOTIFICATION_EVENT_TYPE {
  ADD = "add",
  DELETE = "delete",
  REQUEST = "request",
  CHECKOUT = "checkout",
  INFO = "info",
  WARN = "warn",
  UPDATE = "update",
  SIGNUP = "signup",
  ACCESS = "access",
  EXPIRED = "expired",
}

export interface SocketMessage {
  kind: StompMessageKind;
  payload: any;
  message?: Record<string, any>;
  noti_msg: string;
  noti_id: string;
  noti_timestamp: string;
  isRead: boolean;
}

export interface SocketRecorderMessage {
  kind: StompMessageKind.RECORDER;
  type: "json";
  message: {
    event: SocketMessageEventType;
    recorderId: string;
    recorderName: string;
    mergedSystemId: string;
    mergedSystemName: string;
    accountId: string;
    accountName: string;
    accountNumber: string;
  };
}

export interface SocketUserMessage {
  kind: StompMessageKind.USER;
  payload: {
    event: SocketMessageEventType | "SIGNUP";
    userId: string;
    username: string;
    accounts: {
      accountId: string;
      accountName: string;
      accountNumber: string;
    }[];
  };
}

export interface SocketUserGroupMessage {
  kind: StompMessageKind.USER_GROUP;
  payload: {
    event: SocketMessageEventType;
    userGroupId: string;
    userGroupName: string;
    accountId: string;
    accountName: string;
    accountNumber: string;
  };
}

export interface SocketReportMessage {
  kind: StompMessageKind.REPORT;
  payload: {
    event: SocketMessageEventType;
    reportId: string;
    reportName: string;
    mergedSystemId: string;
    mergedSystemName: string;
    accountId: string;
    accountName: string;
    recorderId: string;
    cameraId: string;
  };
}
export interface SocketVideoShareMessage {
  kind: StompMessageKind.VIDEO_SHARE;
  payload: {
    event: SocketMessageEventType;
    videoShareId: string;
    videoShareName: string;
    accountId: string;
    accountName: string;
    recorderId: string;
    cameraId: string;
  };
}

export interface NotificationCountResponse {
  notiCount: number;
  notiId: string;
  notiTime: number;
}

export interface NotificationMarkRequest {
  email: string;
  notiId: string;
  notiTime: number;
}
export interface NotificationMarkResponse {
  email: string;
  notiId: string;
  notiTime: number;
}
export interface NotificationListRequest extends BasePagination {
  unReadOnly: boolean;
}
export interface NotificationItem {
  notiId: string;
  notiTime: number;
  isRead: boolean;
  accountId: string;
  accountName: string;
  accountNumber: string;
  kind: StompMessageKind;
  eventType: NOTIFICATION_EVENT_TYPE;
  kindId: string;
  parentAccount?: string;
  recorderType?: string;
  recorderName?: string;
  videoTitle?: string;
  username?: string;
  userEmail?: string;
  reportType?: string;
  reportTitle?: string;
  kindName: string;
  subKind?: string;
  notiMsg?: string;
  message?: string;
  opName?: string;
  opEmail?: string;
  targetEmail?: string;
  referenceId?: string;
  targetAccountId?: string;
  subKindId?: string;
  camera?: {
    cameraId: string;
    name: string;
    channel: number;
  }[];
}

export interface NotificationReadMark {
  email: string;
  notiId: string;
  notiTime: number;
  isRead: boolean;
}

export interface NotificationListResponse extends CommonPageResponse {
  result: NotificationItem[];
}
